import { h } from 'preact';
import * as BaseComp from 'components/bolt/signUpForm/signUpForm.js';
import Store from 'store/store';
import { accessNested } from 'utils/utils';

Store.on('MAILING_LIST_DATALAYER', (listName) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'gaEvent',
		eventCategory: 'Mailing List Subscribed',
		eventAction: `${listName}`
	});
});

export default class SignUpForm extends BaseComp.default {

	componentDidUpdate(prevProps, prevState) {
		if (accessNested(Store.get(), 'appData.options.formEmbeds.signUp.formType', '') === 'constantContact' && document.querySelector('[data-qe-id=form-button]')) {

			const constantContactFormBtn = document.querySelector(`[data-qe-id=form-button]`);
			constantContactFormBtn.addEventListener('click', () => {
				if (document.getElementById('success_message_3').style.display === 'none') {
					Store.emit('MAILING_LIST_DATALAYER', 'Constant Contact');
				}
			});
		}
		super.componentDidUpdate(prevProps, prevState);
	}

	closeBanner(reason, e) {
		const userSubscribed = reason === 'subscribed';
		if (userSubscribed && typeof e?.target?.submit === 'function') {
			const formType = accessNested(Store.get(), 'appData.options.formEmbeds.signUp.formType');
			Store.emit('MAILING_LIST_DATALAYER', formType);
		}
		super.closeBanner(reason, e);
	}
}